import $ from "jquery"
import CryptoJS from "crypto-js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
class shareds {
    //物件建立時產生
    constructor(){

        this.TAIWAN = [
            {
              city: "台北市",
              area: ["中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區"]
            },
            {
              city: "新北市",
              area: ["板橋區", "三重區", "中和區", "永和區", "新莊區", "新店區", "土城區", "蘆洲區", "瑞芳區", "淡水區", "汐止區", "三峽區", "樹林區", "鶯歌區", "五股區", "泰山區", "林口區", "八里區", "平溪區", "雙溪區", "貢寮區", "金山區", "萬里區", "三芝區", "石門區"]
            },
            {
              city: "桃園市",
              area: ["桃園區", "中壢區", "平鎮區", "楊梅區", "蘆竹區", "大溪區", "大園區", "觀音區", "八德區", "龍潭區", "新屋區", "龜山區", "復興區"]
            },
            {
              city: "台中市",
              area: ["中區", "東區", "南區", "西區", "北區", "北屯區", "西屯區", "南屯區", "太平區", "大里區", "霧峰區", "烏日區", "豐原區", "后里區", "石岡區", "東勢區", "和平區", "新社區", "潭子區", "大雅區", "神岡區", "大肚區", "沙鹿區", "龍井區", "梧棲區", "清水區", "大甲區", "外埔區", "大安區"]
            },
            {
              city: "台南市",
              area: ["中西區", "東區", "南區", "北區", "安平區", "安南區", "永康區", "歸仁區", "新化區", "左鎮區", "玉井區", "楠西區", "南化區", "仁德區", "關廟區", "龍崎區", "官田區", "麻豆區", "佳里區", "西港區", "七股區", "將軍區", "學甲區", "北門區", "新營區", "後壁區", "白河區", "東山區", "六甲區", "下營區", "柳營區", "鹽水區", "善化區", "大內區", "山上區", "新市區", "安定區"]
            },
            {
              city: "高雄市",
              area: ["新興區", "前金區", "苓雅區", "鹽埕區", "鼓山區", "旗津區", "前鎮區", "三民區", "楠梓區", "小港區", "左營區", "仁武區", "大社區", "岡山區", "路竹區", "阿蓮區", "田寮區", "燕巢區", "橋頭區", "梓官區", "彌陀區", "永安區", "湖內區", "鳳山區", "大寮區", "林園區", "鳥松區", "大樹區", "旗山區", "美濃區", "六龜區", "內門區", "杉林區", "甲仙區", "桃源區", "那瑪夏區", "茂林區", "茄萣區"]
            },
            {
              city: "基隆市",
              area: ["中正區", "七堵區", "暖暖區", "仁愛區", "中山區", "安樂區", "信義區"]
            },
            {
              city: "新竹市",
              area: ["東區", "北區", "香山區"]
            },
            {
              city: "嘉義市",
              area: ["東區", "西區"]
            },
            {
              city: "新竹縣",
              area: ["竹北市", "竹東鎮", "新埔鎮", "關西鎮", "湖口鄉", "新豐鄉", "芎林鄉", "橫山鄉", "北埔鄉", "寶山鄉", "峨眉鄉", "尖石鄉", "五峰鄉"]
            },
            {
              city: "苗栗縣",
              area: ["苗栗市", "頭份市", "竹南鎮", "後龍鎮", "通霄鎮", "苑裡鎮", "卓蘭鎮", "造橋鄉", "西湖鄉", "頭屋鄉", "公館鄉", "銅鑼鄉", "三義鄉", "大湖鄉", "獅潭鄉", "三灣鄉", "南庄鄉", "泰安鄉"]
            },
            {
              city: "彰化縣",
              area: ["彰化市", "員林市", "和美鎮", "鹿港鎮", "溪湖鎮", "二林鎮", "田中鎮", "北斗鎮", "花壇鄉", "芬園鄉", "大村鄉", "永靖鄉", "伸港鄉", "線西鄉", "福興鄉", "秀水鄉", "埔心鄉", "埔鹽鄉", "大城鄉", "芳苑鄉", "竹塘鄉", "社頭鄉", "二水鄉", "田尾鄉", "埤頭鄉", "溪州鄉"]
            },
            {
              city: "南投縣",
              area: ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"]
            },
            {
              city: "雲林縣",
              area: ["斗六市", "斗南鎮", "虎尾鎮", "西螺鎮", "土庫鎮", "北港鎮", "莿桐鄉", "林內鄉", "古坑鄉", "大埤鄉", "崙背鄉", "二崙鄉", "麥寮鄉", "臺西鄉", "東勢鄉", "褒忠鄉", "四湖鄉", "口湖鄉", "水林鄉", "元長鄉"]
            },
            {
              city: "嘉義縣",
              area: ["太保市", "朴子市", "布袋鎮", "大林鎮", "民雄鄉", "溪口鄉", "新港鄉", "六腳鄉", "東石鄉", "義竹鄉", "鹿草鄉", "水上鄉", "中埔鄉", "竹崎鄉", "梅山鄉", "番路鄉", "大埔鄉", "阿里山鄉"]
            },
            {
              city: "屏東縣",
              area: ["屏東市", "潮州鎮", "東港鎮", "恆春鎮", "萬丹鄉", "長治鄉", "麟洛鄉", "九如鄉", "里港鄉", "鹽埔鄉", "高樹鄉", "萬巒鄉", "內埔鄉", "竹田鄉", "新埤鄉", "枋寮鄉", "新園鄉", "崁頂鄉", "林邊鄉", "南州鄉", "佳冬鄉", "琉球鄉", "車城鄉", "滿州鄉", "枋山鄉", "三地門鄉", "霧臺鄉", "瑪家鄉", "泰武鄉", "來義鄉", "春日鄉", "獅子鄉", "牡丹鄉"]
            },
            {
              city: "宜蘭縣",
              area: ["宜蘭市", "羅東鎮", "蘇澳鎮", "頭城鎮", "礁溪鄉", "壯圍鄉", "員山鄉", "冬山鄉", "五結鄉", "三星鄉", "大同鄉", "南澳鄉"]
            },
            {
              city: "花蓮縣",
              area: ["花蓮市", "鳳林鎮", "玉里鎮", "新城鄉", "吉安鄉", "壽豐鄉", "秀林鄉", "光復鄉", "豐濱鄉", "瑞穗鄉", "萬榮鄉", "富里鄉", "卓溪鄉"]
            },
            {
              city: "台東縣",
              area: ["台東市", "成功鎮", "關山鎮", "卑南鄉", "鹿野鄉", "池上鄉", "東河鄉", "長濱鄉", "太麻里鄉", "大武鄉", "綠島鄉", "海端鄉", "延平鄉", "金峰鄉", "達仁鄉", "蘭嶼鄉"]
            },
            {
              city: "澎湖縣",
              area: ["馬公市", "湖西鄉", "白沙鄉", "西嶼鄉", "望安鄉", "七美鄉"]
            },
            {
              city: "金門縣",
              area: ["金城鎮", "金湖鎮", "金沙鎮", "金寧鄉", "烈嶼鄉", "烏坵鄉"]
            },
            {
              city: "連江縣",
              area: ["南竿鄉", "北竿鄉", "莒光鄉", "東引鄉"]
            }
        ]

        this.weekdays = ['日', '一', '二', '三', '四', '五', '六'];
    }

    
    /**********
     * 檢查物件是否不存在
     * obj : any object
     */
    isEmpty = (obj) => {
        if(
            typeof obj == 'undefined'
            || obj == null
            || obj.length<=0
        ){
            return true;
        }
        return false;
    }

    //  判斷是否為空物件
    isEmptyObject(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    isEnglishOnly(str) {
        // 使用正則表達式檢查字串是否只包含半形英文字符 (a-z, A-Z)
        const regex = /^[A-Za-z]+$/;
        return regex.test(str);
    }

    getImageStyle(image) {
        return {
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            // 您可以添加更多樣式
        };
    }
    //傳入起始時間，回傳一個日期陣列 ex:['2024-01-01','2024-01-02','2024-01-03']
    calculateDateRange(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const dates = [];

        for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
            dates.push(new Date(date).toISOString().split('T')[0]);
        }

        return dates;
    }

    formatDateByDate(date, format) {
      // 假設輸入日期是 'yyyy-mm-dd' 格式
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/;
      const match = date.match(regex);

      if (!match) {
          console.error('Invalid date format:', date);
          return 'Invalid date';
      }

      const [_, year, month, day] = match;

      // 使用 Date 物件來計算星期幾
      const d = new Date(`${year}-${month}-${day}`);
      if (isNaN(d.getTime())) {
          console.error('Invalid date:', date);
          return 'Invalid date';
      }

      // 根據格式返回對應部分
      switch (format) {
          case 'yyyy':
              return year;
          case 'mm':
              return month;
          case 'dd':
              return day;
          case 'day':
              return this.weekdays[d.getDay()]; // 返回星期幾
          default:
              return `${year}-${month}-${day}`; // 默認返回完整日期
      }
    }

    //回傳日期 yyyy:mm:dd
    getCurrentDate() {
        //開發時要調用這個設定
        const setting = localStorage.getItem('wildone_dev_setting')
        const date = setting ? JSON.parse(setting).date : null
        if ( date ){
          return date
        }

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
    
        return `${year}-${month}-${day}`;
    }
    //回傳日期 yyyy:mm:dd hh:ii:ss
    getCurrentDateTime() {

        //開發時要調用這個設定
        const setting = localStorage.getItem('wildone_dev_setting')
        const date = setting ? JSON.parse(setting).date : null
        const time = setting ? JSON.parse(setting).time : null
        if ( date && time ){
          return `${date} ${time}`
        }

        const now = new Date();
    
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    //回傳日期 hh:ii:ss
    getCurrentForTime(){
      //開發時要調用這個設定
      const setting = localStorage.getItem('wildone_dev_setting')
      const date = setting ? JSON.parse(setting).date : null
      const time = setting ? JSON.parse(setting).time : null
      if ( date && time ){
        return `${date} ${time}`
      }

      const now = new Date();
  
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
  
      return `${hours}:${minutes}:${seconds}`;
    }

    

    getDayOfWeek(year, month, day) {
        const date = new Date(year, month - 1, day); // 注意，JavaScript 的月份是 0-11
        // const daysOfWeek = ['日', '一', '二', '三', '四', '五', '六'];
        return this.weekdays[date.getDay()];
    }

    formatDate(year, month, day) {
        const formattedYear = year;
        const formattedMonth = String(month).padStart(2, '0'); // 確保月份是兩位數
        const formattedDay = String(day).padStart(2, '0'); // 確保日期是兩位數
        return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    }

    formatIosDate(isoDate) {

      if (
        isoDate == undefined ||
        isoDate == null ||
        isoDate == ""
      ){
        return ''
      }

      if (typeof isoDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(isoDate.trim())) {
        return isoDate.trim()
      }

      const date = new Date(isoDate);
      if (isNaN(date.getTime())) {
        return ''
      }
      
      // 提取 UTC 時間部分
      const year = date.getUTCFullYear(); // 使用 getUTC 方法，保持 UTC 時間
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 使用 getUTCMonth() 來避免本地時區的影響
      const day = String(date.getUTCDate()).padStart(2, '0'); // 使用 getUTCDate() 來避免本地時區的影響
      
      // 返回格式化的日期
      return `${year}-${month}-${day}`;
    }

    formatIosDateTime(isoDate){
        if (
          isoDate == undefined ||
          isoDate == null ||
          isoDate == ""
        ){
          return ''
        }
        const date = new Date(isoDate);
        // 提取日期部分
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        // 提取時間部分
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
    //移除所有其他 HTML 標籤
    replaceAndStripHTML(inputString){
      // 替換 <br> 為 <p>
      let result = inputString.replace(/<br\s*\/?>/gi, '<p>');
      // 移除所有其他 HTML 標籤
      result = result.replace(/<\/?[^>]+(>|$)/g, '');

      return result;
    }

    subtractDaysFromDate(dateStr, daysToSubtract) {
        // 將日期字串轉換為 Date 物件
        const date = new Date(dateStr);
        // 減去指定的天數
        date.setDate(date.getDate() - daysToSubtract);
        // 格式化回 yyyy-mm-dd 格式
        return date.toISOString().split('T')[0];
    }

    formatTimeToHHMM(timeStr) {
      // 檢查時間字串是否包含秒數
      if (timeStr.length === 8) {
          // 若為 "HH:MM:SS" 格式，僅取前五個字元 "HH:MM"
          return timeStr.slice(0, 5);
      }
      // 若時間已經是 "HH:MM" 格式，直接回傳
      return timeStr;
    }

    calculateDateDifference(date1, date2) {

      //處理日期格式不符
      if ( date1 === '' || date2 == ''){
        return 0
      }

      const time1 = new Date(date1).getTime();
      const time2 = new Date(date2).getTime();
    
      const diffInMilliseconds = Math.abs(time1 - time2);
      const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
    
      return diffInDays;
    }

    getFilePath(fileString) {
      // console.log(`fileString=`,fileString) jpg,xxxxxxxxxx
      if (!fileString){
          return ''
      }
      const result = fileString.split(',');
      // console.log('getFilePath=',result)
      if ( result.length <=0 ){
          return result[0] || '';
      }
      return result[1] || '';
    }

    // async downloadPDF(element,fileName){
    //   return Promise(async (resolve)=>{
    //     // 使用 html2canvas 轉換成圖片
    //     const canvas = await html2canvas(element, {
    //         scale: 2, // 提高解析度
    //         useCORS: true, // 避免跨域問題
    //         logging: false
    //     });

    //     const imgData = canvas.toDataURL("image/png");
    //     const pdf = new jsPDF("p", "mm", "a4");

    //     // 計算 PDF 內的比例
    //     const imgWidth = 210; // A4 寬度 (mm)
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //     // 添加圖片到 PDF
    //     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    //     pdf.save(fileName);

    //     resolve()
    //   })
    // }

}
export default shareds